import { apiClient } from './api';

export interface BookingMemo {
  id: string;
  courseId: string;
  content: string;  // Main memo content from API
  type: 'SINGLE' | 'RECURRING';
  date?: string;
  startDate?: string;
  endDate?: string;
  daysOfWeek?: string[];
  isActive: boolean;
}

export const bookingMemoService = {
  async getMemosForDate(courseId: string, date: string): Promise<BookingMemo[]> {
    try {
      const memos = await apiClient.get<BookingMemo[]>(
        `/booking-memos?courseId=${courseId}&date=${date}`
      );
      return memos || [];
    } catch (error) {
      console.error('Error fetching booking memos:', error);
      return [];
    }
  }
};


